import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesRoutingModule } from './pages-routing.module';
import { HomepageComponent } from './homepage/homepage.component';
import { LayoutModule } from '../layout/layout.module';
import { SearchModule } from '../search/search.module';
import { EsperienzeComponent } from './esperienze/esperienze.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbCarouselModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ScopriLaCalabriaComponent } from './scopri-la-calabria/scopri-la-calabria.component';
import { ParchiERiserveComponent } from './parchi-e-riserve/parchi-e-riserve.component';
import { ParcoNazionaleComponent } from './parco-nazionale/parco-nazionale.component';
import { StradeParchiComponent } from './strade-parchi/strade-parchi.component';
import { SentieriPatriarchiComponent } from './sentieri-patriarchi/sentieri-patriarchi.component';
import { AvventuraUmanaComponent } from './avventura-umana/avventura-umana.component';
import { CulturaArberesheComponent } from './cultura-arbereshe/cultura-arbereshe.component';
import { SpiritualitaENaturaComponent } from './spiritualita-e-natura/spiritualita-e-natura.component';
import { PercorsiDiGustoComponent } from './percorsi-di-gusto/percorsi-di-gusto.component';
import { SilaComponent } from './sila/sila.component';
import { ParchiSilaComponent } from './parchi-sila/parchi-sila.component';
import { StoriciVillaggiComponent } from './storici-villaggi/storici-villaggi.component';
import { ArteSpiritualitaSilaComponent } from './arte-spiritualita-sila/arte-spiritualita-sila.component';
import { SerreComponent } from './serre/serre.component';
import { CicloviaParchiSerreComponent } from './ciclovia-parchi-serre/ciclovia-parchi-serre.component';
import { SerraSanBrunoComponent } from './serra-san-bruno/serra-san-bruno.component';
import { GrifalcoComponent } from './grifalco/grifalco.component';
import { AspromonteComponent } from './aspromonte/aspromonte.component';
import { CicloviaParchiAspromonteComponent } from './ciclovia-parchi-aspromonte/ciclovia-parchi-aspromonte.component';
import { GeraceComponent } from './gerace/gerace.component';
import { AreaGrecanicaComponent } from './area-grecanica/area-grecanica.component';
import { ValliCupeComponent } from './valli-cupe/valli-cupe.component';
import { TarsiaFoceCratiComponent } from './tarsia-foce-crati/tarsia-foce-crati.component';
import { AreeMarineProtetteComponent } from './aree-marine-protette/aree-marine-protette.component';
import { CamminiOutdoorComponent } from './cammini-outdoor/cammini-outdoor.component';
import { CicloturismoComponent } from './cicloturismo/cicloturismo.component';
import { NaturaBenessereComponent } from './natura-benessere/natura-benessere.component';
import { StoriaArteSpiritualitaComponent } from './storia-arte-spiritualita/storia-arte-spiritualita.component';
import { GustoTradizioniComponent } from './gusto-tradizioni/gusto-tradizioni.component';
import { CalabriaForKidsComponent } from './calabria-for-kids/calabria-for-kids.component';
import { ItinerariDidatticiComponent } from './itinerari-didattici/itinerari-didattici.component';
import { SitiUnescoComponent } from './siti-unesco/siti-unesco.component';
import { BorghiStoriciComponent } from './borghi-storici/borghi-storici.component';
import { MuseiComponent } from './musei/musei.component';
import { LuoghiArteComponent } from './luoghi-arte/luoghi-arte.component';
import { LoginComponent } from './login/login.component';
import { ChiSiamoComponent } from './chi-siamo/chi-siamo.component';
import { EventiNewsComponent } from './eventi-news/eventi-news.component';
import { InfoComponent } from './info/info.component';
import { OfferteComponent } from './offerte/offerte.component';
import { ServiziComponent } from './servizi/servizi.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MappeComponent } from './mappe/mappe.component';


@NgModule({
  declarations: [
    HomepageComponent,
    EsperienzeComponent,
    ScopriLaCalabriaComponent,
    ParchiERiserveComponent,
    ParcoNazionaleComponent,
    StradeParchiComponent,
    SentieriPatriarchiComponent,
    AvventuraUmanaComponent,
    CulturaArberesheComponent,
    SpiritualitaENaturaComponent,
    PercorsiDiGustoComponent,
    SilaComponent,
    ParchiSilaComponent,
    StoriciVillaggiComponent,
    ArteSpiritualitaSilaComponent,
    SerreComponent,
    CicloviaParchiSerreComponent,
    SerraSanBrunoComponent,
    GrifalcoComponent,
    AspromonteComponent,
    CicloviaParchiAspromonteComponent,
    GeraceComponent,
    AreaGrecanicaComponent,
    ValliCupeComponent,
    TarsiaFoceCratiComponent,
    AreeMarineProtetteComponent,
    CamminiOutdoorComponent,
    CicloturismoComponent,
    NaturaBenessereComponent,
    StoriaArteSpiritualitaComponent,
    GustoTradizioniComponent,
    CalabriaForKidsComponent,
    ItinerariDidatticiComponent,
    SitiUnescoComponent,
    BorghiStoriciComponent,
    MuseiComponent,
    LuoghiArteComponent,
    LoginComponent,
    ChiSiamoComponent,
    EventiNewsComponent,
    InfoComponent,
    OfferteComponent,
    ServiziComponent,
    MappeComponent
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    LayoutModule,
    SearchModule,
    ReactiveFormsModule,
    FormsModule,
    CarouselModule,
  ]
})
export class PagesModule { }
